import files from './files';
import layout from './layout';

export { files, layout };



/** WEBPACK FOOTER **
 ** ./src/reducers/index.js
 **/